
import { useSelector } from 'react-redux';

const  useCheckAuthorization = (required_permissions=[]) => {
    const { userData: {permission_code} } = useSelector(state => state.user)
    
    return required_permissions.some(r=> permission_code.includes(r))
}

export default useCheckAuthorization;